const normalizeRecordId = id => {
    if (typeof id === 'string') {
        return id;
    }

    if (id && typeof id === 'object' && typeof id.value === 'string') {
        return id.value;
    }

    return null;
};

export const getCampaignTileImagePath = (id, cacheKey) => {
    const recordId = normalizeRecordId(id);
    if (!recordId) {
        return null;
    }

    const path = `/ad/${recordId}/image`;

    if (!cacheKey) {
        return path;
    }

    const timestamp = Number.isNaN(Date.parse(cacheKey)) ? cacheKey : Date.parse(cacheKey);
    return `${path}?t=${timestamp}`;
};

export { normalizeRecordId };
